import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const projectDataSlice = createSlice({
  name: "projectData",
  initialState: { isDataFetched: false },
  reducers: {
    setProjectData: (_state: any, action: PayloadAction<any>) => ({ ...action.payload, isDataFetched: true }),
  },
});

const allSpacesInProjectSlice = createSlice({
  name: "allSpacesInProject",
  initialState: [],
  reducers: {
    setAllSpacesInProjects: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const spaceDataSlice = createSlice({
  name: "spaceData",
  initialState: [],
  reducers: {
    setSpaceData: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const breadCrumbDataSlice = createSlice({
  name: "breadCrumbData",
  initialState: [],
  reducers: {
    setBreadCrumbData: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setProjectData } = projectDataSlice.actions;
export const { setAllSpacesInProjects } = allSpacesInProjectSlice.actions;
export const { setSpaceData } = spaceDataSlice.actions;
export const { setBreadCrumbData } = breadCrumbDataSlice.actions;

export const projectData = projectDataSlice.reducer;
export const allSpacesInProject = allSpacesInProjectSlice.reducer;
export const spaceData = spaceDataSlice.reducer;
export const breadCrumbData = breadCrumbDataSlice.reducer;

export default breadCrumbDataSlice.reducer;
